import { createBrowserRouter } from "react-router-dom";
import { LandingPage, HomePage, CallPage, NotFoundPage } from "./pages";
import { Routes } from "./routes";

import { FallbackComponent } from "./components/FallbackComponent";

export const router = createBrowserRouter([
  {
    path: Routes.LANDING,
    element: <LandingPage />,
    errorElement: <FallbackComponent />,
  },
  {
    path: Routes.HOME,
    element: <HomePage />,
    errorElement: <FallbackComponent />,
  },
  {
    path: Routes.CALL,
    element: <CallPage />,
    errorElement: <FallbackComponent />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
    errorElement: <FallbackComponent />,
  },
]);
